module.exports = __webpack_public_path__ + "static/media/job_id.249f4979.svg";